import styled from 'styled-components';
import BalconySvg from '../../assets/amenities/balcony.svg';

const BalconyIcon = styled(BalconySvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '2.4rem'};
  margin: ${props => props.margin};
`;

export default BalconyIcon;
